/* @flow */
import * as React from 'react';
import idx from 'idx';
import { graphql } from 'react-apollo';
import { withRouter } from 'app/context/Router';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import FEATURE_SPECIFIC_DEEPLINK_QUERY from './queries/FeatureSpecificDeeplinkQuery.gql';

import type {
  FeatureSpecificDeeplink,
  OrgPermission,
} from './queries/__generated__/FeatureSpecificDeeplink';

type Props = {
  data: ReactApolloData<FeatureSpecificDeeplink>,
  router: *,
  orgPermissionCondition: OrgPermission,
  urlPath: string,
};

class FeatureSpecificIndexHandler extends React.Component<Props> {
  componentDidMount() {
    const { data } = this.props;
    const featureDeeplink = idx(data, _ => _.me.featureDeeplink);
    if (featureDeeplink) {
      this.redirect(featureDeeplink);
    }
  }

  componentDidUpdate(prevProps: Props) {
    const prevData = prevProps.data;
    const { data } = this.props;
    const featureDeeplink = idx(data, _ => _.me.featureDeeplink);
    if (!prevData.me && featureDeeplink) {
      this.redirect(featureDeeplink);
    }
  }

  redirect(pathname: string) {
    const { router } = this.props;
    const { query } = router.location;
    router.replace({
      pathname,
      query,
    });
  }

  render() {
    return <CenteredLoadingIndicator />;
  }
}

const withDeeplink = graphql(FEATURE_SPECIFIC_DEEPLINK_QUERY, {
  options: ({ orgPermissionCondition, urlPath }) => ({
    notifyOnNetworkStatusChange: true,
    variables: {
      orgPermissionCondition,
      urlPath,
    },
  }),
});

export { FeatureSpecificIndexHandler };
export default withRouter(withDeeplink(FeatureSpecificIndexHandler));
